module.exports = __webpack_public_path__ + "img/logo-colors.d92f57ac.svg";